import React from "react"
// import { StaticImage } from "gatsby-plugin-image"


function WorksFooter({ carouselStyle, mosaicStyle, mailStyle, slashStyle, handleChangeMosaic }) {
  return (
    <div className="worksFooter">
      <div>
        <span
          className={carouselStyle}
          role="button"
          onMouseDown={() => handleChangeMosaic(false)}
          tabIndex="0"
        >
          carrusel
        </span>
        <span className={slashStyle}>/</span>
        <span
          className={mosaicStyle}
          role="button"
          onMouseDown={() => handleChangeMosaic(true)}
          tabIndex="0"
        >
          mosaico
        </span>
      </div>
      <a href="mailto:hola@randomlab.com.ar" className={mailStyle}>hola@randomlab.com.ar</a>
    </div>
  )
}

export default WorksFooter
